/**
 * Tive API
 *
 * Contact: support@tive.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AccountLocationSharingPermissionDto } from '../model/accountLocationSharingPermissionDto';
// @ts-ignore
import { AlertTriggerLocationEntityType } from '../model/alertTriggerLocationEntityType';
// @ts-ignore
import { BulkEnableLocationShareModel } from '../model/bulkEnableLocationShareModel';
// @ts-ignore
import { BulkSetLabelModel } from '../model/bulkSetLabelModel';
// @ts-ignore
import { CoordinateAddress } from '../model/coordinateAddress';
// @ts-ignore
import { CoordinateAddressListLengthResult } from '../model/coordinateAddressListLengthResult';
// @ts-ignore
import { CoordinateAddressType } from '../model/coordinateAddressType';
// @ts-ignore
import { DistanceUnit } from '../model/distanceUnit';
// @ts-ignore
import { DuplicateCoordinateAddressEntity } from '../model/duplicateCoordinateAddressEntity';
// @ts-ignore
import { LegCoordinateAddress } from '../model/legCoordinateAddress';
// @ts-ignore
import { LocationCollaborator } from '../model/locationCollaborator';
// @ts-ignore
import { LocationShipmentListLengthResult } from '../model/locationShipmentListLengthResult';
// @ts-ignore
import { MergeIntoExistingLocationModel } from '../model/mergeIntoExistingLocationModel';
// @ts-ignore
import { MergeIntoNewLocationModel } from '../model/mergeIntoNewLocationModel';
// @ts-ignore
import { ODataResponse } from '../model/oDataResponse';
// @ts-ignore
import { QueryCoordinateBasedOnNameAndFullAddressDto } from '../model/queryCoordinateBasedOnNameAndFullAddressDto';
// @ts-ignore
import { SetStandardizedNodeTypeModel } from '../model/setStandardizedNodeTypeModel';
// @ts-ignore
import { SlimPortCoordinateAddress } from '../model/slimPortCoordinateAddress';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class AddressService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Get coordinate addresses matching list of IDs (Role Permissions Required: LocationsView)
   * @endpoint get /api/addresses/addressesByIds
   * @param coordinateAddressIds
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesAddressesByIdsGet(
    coordinateAddressIds?: Array<number>,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<CoordinateAddress>>;
  public apiAddressesAddressesByIdsGet(
    coordinateAddressIds?: Array<number>,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<CoordinateAddress>>>;
  public apiAddressesAddressesByIdsGet(
    coordinateAddressIds?: Array<number>,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<CoordinateAddress>>>;
  public apiAddressesAddressesByIdsGet(
    coordinateAddressIds?: Array<number>,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'coordinateAddressIds',
      <any>coordinateAddressIds,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/addressesByIds`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CoordinateAddress>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Add Labels on Address (Role Permissions Required: LocationsEdit)
   * @endpoint post /api/addresses/BulkAddLabel
   * @param xTiveAccountId Account Id
   * @param bulkSetLabelModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesBulkAddLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesBulkAddLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesBulkAddLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesBulkAddLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/BulkAddLabel`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: bulkSetLabelModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * End point which takes a csv file for location creation in bulk (Role Permissions Required: FlagsCanImportBulkLocations; LocationsEdit)
   * @endpoint post /api/addresses/bulkCreation
   * @param xTiveAccountId Account Id
   * @param batchLocationCsvFile
   * @param distanceUnits
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesBulkCreationPost(
    xTiveAccountId?: number,
    batchLocationCsvFile?: Blob,
    distanceUnits?: DistanceUnit,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesBulkCreationPost(
    xTiveAccountId?: number,
    batchLocationCsvFile?: Blob,
    distanceUnits?: DistanceUnit,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesBulkCreationPost(
    xTiveAccountId?: number,
    batchLocationCsvFile?: Blob,
    distanceUnits?: DistanceUnit,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesBulkCreationPost(
    xTiveAccountId?: number,
    batchLocationCsvFile?: Blob,
    distanceUnits?: DistanceUnit,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['multipart/form-data'];

    const canConsumeForm = this.canConsumeForm(consumes);

    let localVarFormParams: { append(param: string, value: any): any };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    localVarUseForm = canConsumeForm;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({ encoder: this.encoder });
    }

    if (batchLocationCsvFile !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('BatchLocationCsvFile', <any>batchLocationCsvFile) as any) ||
        localVarFormParams;
    }
    if (distanceUnits !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('DistanceUnits', <any>distanceUnits) as any) ||
        localVarFormParams;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/bulkCreation`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Bulk share locations with external organizations (Role Permissions Required: LocationsShareExternally)
   * @endpoint post /api/addresses/bulkEnableLocationShareExternal
   * @param xTiveAccountId Account Id
   * @param bulkEnableLocationShareModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesBulkEnableLocationShareExternalPost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesBulkEnableLocationShareExternalPost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesBulkEnableLocationShareExternalPost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesBulkEnableLocationShareExternalPost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/bulkEnableLocationShareExternal`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: bulkEnableLocationShareModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Bulk share locations (Role Permissions Required: CanUseShareLocationFeature; LocationsShare)
   * @endpoint post /api/addresses/bulkEnableLocationShare
   * @param xTiveAccountId Account Id
   * @param bulkEnableLocationShareModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesBulkEnableLocationSharePost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<number>>;
  public apiAddressesBulkEnableLocationSharePost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<number>>>;
  public apiAddressesBulkEnableLocationSharePost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<number>>>;
  public apiAddressesBulkEnableLocationSharePost(
    xTiveAccountId?: number,
    bulkEnableLocationShareModel?: BulkEnableLocationShareModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/bulkEnableLocationShare`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<number>>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: bulkEnableLocationShareModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Replace Labels on Address (Role Permissions Required: LocationsEdit)
   * @endpoint post /api/addresses/BulkSetLabel
   * @param xTiveAccountId Account Id
   * @param bulkSetLabelModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesBulkSetLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesBulkSetLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesBulkSetLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesBulkSetLabelPost(
    xTiveAccountId?: number,
    bulkSetLabelModel?: BulkSetLabelModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/BulkSetLabel`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: bulkSetLabelModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Checks if address with same coordinates and different FullAddress exists. (Role Permissions Required: LocationsView)
   * @endpoint get /api/addresses/checkSameCoordinatesDifferentAddressExists
   * @param id
   * @param latitude
   * @param longitude
   * @param locationName
   * @param exactName
   * @param locationAddress
   * @param numberOfShipmentsUsing
   * @param disabled
   * @param searchTerm
   * @param pageSize
   * @param pageNumber
   * @param sortField
   * @param sortOrder
   * @param addressType
   * @param isShipmentsCountUsed
   * @param loadCollaborators
   * @param loadLabels
   * @param loadCreator
   * @param includeDefaultLocations
   * @param includeSharedLocations
   * @param includeSharedLocationsExternally
   * @param excludeTotalCount
   * @param getInheritedAddressByParentLocationId
   * @param onlySavedLocations
   * @param loadSharedFromOrganizationName
   * @param prioritizeExternalSharedAddresses
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesCheckSameCoordinatesDifferentAddressExistsGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesCheckSameCoordinatesDifferentAddressExistsGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesCheckSameCoordinatesDifferentAddressExistsGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesCheckSameCoordinatesDifferentAddressExistsGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Id',
      <any>id,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Latitude',
      <any>latitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Longitude',
      <any>longitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationName',
      <any>locationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExactName',
      <any>exactName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationAddress',
      <any>locationAddress,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'NumberOfShipmentsUsing',
      <any>numberOfShipmentsUsing,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Disabled',
      <any>disabled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SearchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortField',
      <any>sortField,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortOrder',
      <any>sortOrder,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'AddressType',
      <any>addressType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IsShipmentsCountUsed',
      <any>isShipmentsCountUsed,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadLabels',
      <any>loadLabels,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCreator',
      <any>loadCreator,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeDefaultLocations',
      <any>includeDefaultLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocations',
      <any>includeSharedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocationsExternally',
      <any>includeSharedLocationsExternally,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExcludeTotalCount',
      <any>excludeTotalCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'GetInheritedAddressByParentLocationId',
      <any>getInheritedAddressByParentLocationId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'OnlySavedLocations',
      <any>onlySavedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadSharedFromOrganizationName',
      <any>loadSharedFromOrganizationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PrioritizeExternalSharedAddresses',
      <any>prioritizeExternalSharedAddresses,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/checkSameCoordinatesDifferentAddressExists`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Deactivate a specific coordinate address (Role Permissions Required: LocationsCreate)
   * @endpoint put /api/addresses/deactivate/{id}
   * @param id
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesDeactivateIdPut(
    id: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesDeactivateIdPut(
    id: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesDeactivateIdPut(
    id: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesDeactivateIdPut(
    id: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiAddressesDeactivateIdPut.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/deactivate/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Restores a derived location to its default location (deletes the derived location) (Role Permissions Required: FlagsCanUseDefaultLocations)
   * @endpoint put /api/addresses/derived/{locationId}
   * @param locationId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesDerivedLocationIdPut(
    locationId: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesDerivedLocationIdPut(
    locationId: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesDerivedLocationIdPut(
    locationId: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesDerivedLocationIdPut(
    locationId: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (locationId === null || locationId === undefined) {
      throw new Error(
        'Required parameter locationId was null or undefined when calling apiAddressesDerivedLocationIdPut.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/derived/${this.configuration.encodeParam({ name: 'locationId', value: locationId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Returns true if there are locations for the current account with the selected node type/label(s) (Role Permissions Required: LocationsView)
   * @endpoint get /api/addresses/doAllLocationsExist
   * @param ids Location ids, node type ids or label ids
   * @param entityType Type of location selected
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesDoAllLocationsExistGet(
    ids?: Array<number>,
    entityType?: AlertTriggerLocationEntityType,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesDoAllLocationsExistGet(
    ids?: Array<number>,
    entityType?: AlertTriggerLocationEntityType,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesDoAllLocationsExistGet(
    ids?: Array<number>,
    entityType?: AlertTriggerLocationEntityType,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesDoAllLocationsExistGet(
    ids?: Array<number>,
    entityType?: AlertTriggerLocationEntityType,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ids',
      <any>ids,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'entityType',
      <any>entityType,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/doAllLocationsExist`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get duplicated coordinate addresses (Role Permissions Required: LocationsView) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint get /api/addresses/duplicateAddressesByAccount
   * @param loadCollaborators
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesDuplicateAddressesByAccountGet(
    loadCollaborators?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<DuplicateCoordinateAddressEntity>>;
  public apiAddressesDuplicateAddressesByAccountGet(
    loadCollaborators?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<DuplicateCoordinateAddressEntity>>>;
  public apiAddressesDuplicateAddressesByAccountGet(
    loadCollaborators?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<DuplicateCoordinateAddressEntity>>>;
  public apiAddressesDuplicateAddressesByAccountGet(
    loadCollaborators?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/duplicateAddressesByAccount`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<DuplicateCoordinateAddressEntity>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get count of duplicate location groups (Role Permissions Required: LocationsEdit)
   * @endpoint get /api/addresses/duplicateLocationsCount
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesDuplicateLocationsCountGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<number>;
  public apiAddressesDuplicateLocationsCountGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<number>>;
  public apiAddressesDuplicateLocationsCountGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<number>>;
  public apiAddressesDuplicateLocationsCountGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/duplicateLocationsCount`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<number>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get coordinate addresses (Role Permissions Required: LocationsView) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint get /api/addresses
   * @param id
   * @param latitude
   * @param longitude
   * @param locationName
   * @param exactName
   * @param locationAddress
   * @param numberOfShipmentsUsing
   * @param disabled
   * @param searchTerm
   * @param pageSize
   * @param pageNumber
   * @param sortField
   * @param sortOrder
   * @param addressType
   * @param isShipmentsCountUsed
   * @param loadCollaborators
   * @param loadLabels
   * @param loadCreator
   * @param includeDefaultLocations
   * @param includeSharedLocations
   * @param includeSharedLocationsExternally
   * @param excludeTotalCount
   * @param getInheritedAddressByParentLocationId
   * @param onlySavedLocations
   * @param loadSharedFromOrganizationName
   * @param prioritizeExternalSharedAddresses
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CoordinateAddressListLengthResult>;
  public apiAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CoordinateAddressListLengthResult>>;
  public apiAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CoordinateAddressListLengthResult>>;
  public apiAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Id',
      <any>id,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Latitude',
      <any>latitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Longitude',
      <any>longitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationName',
      <any>locationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExactName',
      <any>exactName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationAddress',
      <any>locationAddress,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'NumberOfShipmentsUsing',
      <any>numberOfShipmentsUsing,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Disabled',
      <any>disabled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SearchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortField',
      <any>sortField,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortOrder',
      <any>sortOrder,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'AddressType',
      <any>addressType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IsShipmentsCountUsed',
      <any>isShipmentsCountUsed,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadLabels',
      <any>loadLabels,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCreator',
      <any>loadCreator,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeDefaultLocations',
      <any>includeDefaultLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocations',
      <any>includeSharedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocationsExternally',
      <any>includeSharedLocationsExternally,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExcludeTotalCount',
      <any>excludeTotalCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'GetInheritedAddressByParentLocationId',
      <any>getInheritedAddressByParentLocationId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'OnlySavedLocations',
      <any>onlySavedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadSharedFromOrganizationName',
      <any>loadSharedFromOrganizationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PrioritizeExternalSharedAddresses',
      <any>prioritizeExternalSharedAddresses,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CoordinateAddressListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns locations that are valid to be used for alert triggers (Role Permissions Required: LocationsView)
   * @endpoint get /api/addresses/getAddressesForAlertTriggers
   * @param pageSize Locations per page
   * @param pageNumber Current page
   * @param search Optional search query
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetAddressesForAlertTriggersGet(
    pageSize?: number,
    pageNumber?: number,
    search?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<CoordinateAddress>>;
  public apiAddressesGetAddressesForAlertTriggersGet(
    pageSize?: number,
    pageNumber?: number,
    search?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<CoordinateAddress>>>;
  public apiAddressesGetAddressesForAlertTriggersGet(
    pageSize?: number,
    pageNumber?: number,
    search?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<CoordinateAddress>>>;
  public apiAddressesGetAddressesForAlertTriggersGet(
    pageSize?: number,
    pageNumber?: number,
    search?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'search',
      <any>search,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getAddressesForAlertTriggers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CoordinateAddress>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get coordinate addresses  for a shipment
   * @endpoint get /api/addresses/getCoordinateAddressesOfShipment
   * @param internalShipmentId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetCoordinateAddressesOfShipmentGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<LegCoordinateAddress>>;
  public apiAddressesGetCoordinateAddressesOfShipmentGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<LegCoordinateAddress>>>;
  public apiAddressesGetCoordinateAddressesOfShipmentGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<LegCoordinateAddress>>>;
  public apiAddressesGetCoordinateAddressesOfShipmentGet(
    internalShipmentId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'internalShipmentId',
      <any>internalShipmentId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getCoordinateAddressesOfShipment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<LegCoordinateAddress>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get coordinate addresses  for a shipment template (Role Permissions Required: ShipmentTemplatesView)
   * @endpoint get /api/addresses/getCoordinateAddressesOfTemplate
   * @param shipmentTemplateId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetCoordinateAddressesOfTemplateGet(
    shipmentTemplateId?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<LegCoordinateAddress>>;
  public apiAddressesGetCoordinateAddressesOfTemplateGet(
    shipmentTemplateId?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<LegCoordinateAddress>>>;
  public apiAddressesGetCoordinateAddressesOfTemplateGet(
    shipmentTemplateId?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<LegCoordinateAddress>>>;
  public apiAddressesGetCoordinateAddressesOfTemplateGet(
    shipmentTemplateId?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'shipmentTemplateId',
      <any>shipmentTemplateId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getCoordinateAddressesOfTemplate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<LegCoordinateAddress>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * return a list of found addresses based on names and full addresses (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView)
   * @endpoint post /api/addresses/getCoordinatesByNameAndAddressForAccount
   * @param xTiveAccountId Account Id
   * @param queryCoordinateBasedOnNameAndFullAddressDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetCoordinatesByNameAndAddressForAccountPost(
    xTiveAccountId?: number,
    queryCoordinateBasedOnNameAndFullAddressDto?: QueryCoordinateBasedOnNameAndFullAddressDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<SlimPortCoordinateAddress>>;
  public apiAddressesGetCoordinatesByNameAndAddressForAccountPost(
    xTiveAccountId?: number,
    queryCoordinateBasedOnNameAndFullAddressDto?: QueryCoordinateBasedOnNameAndFullAddressDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<SlimPortCoordinateAddress>>>;
  public apiAddressesGetCoordinatesByNameAndAddressForAccountPost(
    xTiveAccountId?: number,
    queryCoordinateBasedOnNameAndFullAddressDto?: QueryCoordinateBasedOnNameAndFullAddressDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<SlimPortCoordinateAddress>>>;
  public apiAddressesGetCoordinatesByNameAndAddressForAccountPost(
    xTiveAccountId?: number,
    queryCoordinateBasedOnNameAndFullAddressDto?: QueryCoordinateBasedOnNameAndFullAddressDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getCoordinatesByNameAndAddressForAccount`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SlimPortCoordinateAddress>>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: queryCoordinateBasedOnNameAndFullAddressDto,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get location collaborators (Role Permissions Required: ShipmentsViewAccess)
   * @endpoint get /api/addresses/getLocationCollaborators
   * @param fullAddress
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetLocationCollaboratorsGet(
    fullAddress?: string,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<LocationCollaborator>>;
  public apiAddressesGetLocationCollaboratorsGet(
    fullAddress?: string,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<LocationCollaborator>>>;
  public apiAddressesGetLocationCollaboratorsGet(
    fullAddress?: string,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<LocationCollaborator>>>;
  public apiAddressesGetLocationCollaboratorsGet(
    fullAddress?: string,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fullAddress',
      <any>fullAddress,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getLocationCollaborators`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<LocationCollaborator>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns all found ports for the given coordinates (Role Permissions Required: LocationsView; FlagsCanImportBulkLocations; FlagsCanUseDefaultLocations)
   * @endpoint post /api/addresses/getPortsByCoordinates
   * @param xTiveAccountId Account Id
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetPortsByCoordinatesPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<SlimPortCoordinateAddress>>;
  public apiAddressesGetPortsByCoordinatesPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<SlimPortCoordinateAddress>>>;
  public apiAddressesGetPortsByCoordinatesPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<SlimPortCoordinateAddress>>>;
  public apiAddressesGetPortsByCoordinatesPost(
    xTiveAccountId?: number,
    requestBody?: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getPortsByCoordinates`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SlimPortCoordinateAddress>>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: requestBody,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * This endpoint is strictly used from bulk location import to check if accounts in the rows have access on sharing locations. (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView; LocationsCreate; CanUseShareLocationFeature; LocationsShare)
   * @endpoint post /api/addresses/getSharingPermissionBulkForAccounts
   * @param xTiveAccountId Account Id
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetSharingPermissionBulkForAccountsPost(
    xTiveAccountId?: number,
    requestBody?: Array<number>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<AccountLocationSharingPermissionDto>>;
  public apiAddressesGetSharingPermissionBulkForAccountsPost(
    xTiveAccountId?: number,
    requestBody?: Array<number>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<AccountLocationSharingPermissionDto>>>;
  public apiAddressesGetSharingPermissionBulkForAccountsPost(
    xTiveAccountId?: number,
    requestBody?: Array<number>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<AccountLocationSharingPermissionDto>>>;
  public apiAddressesGetSharingPermissionBulkForAccountsPost(
    xTiveAccountId?: number,
    requestBody?: Array<number>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getSharingPermissionBulkForAccounts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AccountLocationSharingPermissionDto>>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: requestBody,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get coordinate addresses (Role Permissions Required: LocationsView)
   * @endpoint get /api/addresses/getShipmentCoordinateAddresses
   * @param id
   * @param latitude
   * @param longitude
   * @param locationName
   * @param exactName
   * @param locationAddress
   * @param numberOfShipmentsUsing
   * @param disabled
   * @param searchTerm
   * @param pageSize
   * @param pageNumber
   * @param sortField
   * @param sortOrder
   * @param addressType
   * @param isShipmentsCountUsed
   * @param loadCollaborators
   * @param loadLabels
   * @param loadCreator
   * @param includeDefaultLocations
   * @param includeSharedLocations
   * @param includeSharedLocationsExternally
   * @param excludeTotalCount
   * @param getInheritedAddressByParentLocationId
   * @param onlySavedLocations
   * @param loadSharedFromOrganizationName
   * @param prioritizeExternalSharedAddresses
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetShipmentCoordinateAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CoordinateAddressListLengthResult>;
  public apiAddressesGetShipmentCoordinateAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CoordinateAddressListLengthResult>>;
  public apiAddressesGetShipmentCoordinateAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CoordinateAddressListLengthResult>>;
  public apiAddressesGetShipmentCoordinateAddressesGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Id',
      <any>id,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Latitude',
      <any>latitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Longitude',
      <any>longitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationName',
      <any>locationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExactName',
      <any>exactName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationAddress',
      <any>locationAddress,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'NumberOfShipmentsUsing',
      <any>numberOfShipmentsUsing,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Disabled',
      <any>disabled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SearchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortField',
      <any>sortField,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortOrder',
      <any>sortOrder,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'AddressType',
      <any>addressType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IsShipmentsCountUsed',
      <any>isShipmentsCountUsed,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadLabels',
      <any>loadLabels,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCreator',
      <any>loadCreator,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeDefaultLocations',
      <any>includeDefaultLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocations',
      <any>includeSharedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocationsExternally',
      <any>includeSharedLocationsExternally,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExcludeTotalCount',
      <any>excludeTotalCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'GetInheritedAddressByParentLocationId',
      <any>getInheritedAddressByParentLocationId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'OnlySavedLocations',
      <any>onlySavedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadSharedFromOrganizationName',
      <any>loadSharedFromOrganizationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PrioritizeExternalSharedAddresses',
      <any>prioritizeExternalSharedAddresses,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getShipmentCoordinateAddresses`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CoordinateAddressListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get shipments that are using provided coordinate address (Role Permissions Required: ViewNewLocationPage)
   * @endpoint get /api/addresses/GetShipmentsByAddress/{id}
   * @param id
   * @param pageSize
   * @param pageNumber
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetShipmentsByAddressIdGet(
    id: number,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<LocationShipmentListLengthResult>;
  public apiAddressesGetShipmentsByAddressIdGet(
    id: number,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<LocationShipmentListLengthResult>>;
  public apiAddressesGetShipmentsByAddressIdGet(
    id: number,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<LocationShipmentListLengthResult>>;
  public apiAddressesGetShipmentsByAddressIdGet(
    id: number,
    pageSize?: number,
    pageNumber?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiAddressesGetShipmentsByAddressIdGet.',
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/GetShipmentsByAddress/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<LocationShipmentListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get time zone of a location by it\&#39;s coordinates
   * @endpoint get /api/addresses/getTimeZoneByCoordinates
   * @param lat
   * @param lon
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesGetTimeZoneByCoordinatesGet(
    lat?: number,
    lon?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<string>;
  public apiAddressesGetTimeZoneByCoordinatesGet(
    lat?: number,
    lon?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<string>>;
  public apiAddressesGetTimeZoneByCoordinatesGet(
    lat?: number,
    lon?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<string>>;
  public apiAddressesGetTimeZoneByCoordinatesGet(
    lat?: number,
    lon?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'lat',
      <any>lat,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'lon',
      <any>lon,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/getTimeZoneByCoordinates`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<string>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get Coordinate Address by specific Id (Role Permissions Required: LocationsView) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint get /api/addresses/{id}
   * @param id
   * @param loadCollaborators
   * @param loadLabels
   * @param getInheritedAddress
   * @param hideDisabled
   * @param loadShipmentCounts Specifies whether to load the number of shipments where the address is used as the origin or destination in shipment legs.  Note: Enabling this option may significantly slow down the request due to the additional data retrieval.  Important: The platform sends this as false by default, but the public API expects the shipment counts to be loaded hence why this is by default true
   * @param loadCreator
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesIdGet(
    id: number,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    getInheritedAddress?: boolean,
    hideDisabled?: boolean,
    loadShipmentCounts?: boolean,
    loadCreator?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CoordinateAddress>;
  public apiAddressesIdGet(
    id: number,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    getInheritedAddress?: boolean,
    hideDisabled?: boolean,
    loadShipmentCounts?: boolean,
    loadCreator?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CoordinateAddress>>;
  public apiAddressesIdGet(
    id: number,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    getInheritedAddress?: boolean,
    hideDisabled?: boolean,
    loadShipmentCounts?: boolean,
    loadCreator?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CoordinateAddress>>;
  public apiAddressesIdGet(
    id: number,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    getInheritedAddress?: boolean,
    hideDisabled?: boolean,
    loadShipmentCounts?: boolean,
    loadCreator?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiAddressesIdGet.',
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadLabels',
      <any>loadLabels,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'getInheritedAddress',
      <any>getInheritedAddress,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'hideDisabled',
      <any>hideDisabled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadShipmentCounts',
      <any>loadShipmentCounts,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loadCreator',
      <any>loadCreator,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CoordinateAddress>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Update an existing Coordinate Address (Role Permissions Required: LocationsEdit) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint put /api/addresses/{id}
   * @param id
   * @param skipSharedStateUpdate if the internal sharing or external sharing state needs to be updated, pass False. Otherwise pass True
   * @param skipLabelsUpdate If true the assigned labels won\&#39;t be updated.
   * @param skipCheckNodeType If true skip node type validation.
   * @param xTiveAccountId Account Id
   * @param coordinateAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesIdPut(
    id: number,
    skipSharedStateUpdate?: boolean,
    skipLabelsUpdate?: boolean,
    skipCheckNodeType?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesIdPut(
    id: number,
    skipSharedStateUpdate?: boolean,
    skipLabelsUpdate?: boolean,
    skipCheckNodeType?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesIdPut(
    id: number,
    skipSharedStateUpdate?: boolean,
    skipLabelsUpdate?: boolean,
    skipCheckNodeType?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesIdPut(
    id: number,
    skipSharedStateUpdate?: boolean,
    skipLabelsUpdate?: boolean,
    skipCheckNodeType?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiAddressesIdPut.',
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipSharedStateUpdate',
      <any>skipSharedStateUpdate,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipLabelsUpdate',
      <any>skipLabelsUpdate,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCheckNodeType',
      <any>skipCheckNodeType,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: coordinateAddress,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets latest batch info for logged in user (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView)
   * @endpoint get /api/addresses/latestLocationBatchForUser
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesLatestLocationBatchForUserGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesLatestLocationBatchForUserGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesLatestLocationBatchForUserGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesLatestLocationBatchForUserGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/latestLocationBatchForUser`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets batch info given a batch id (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView)
   * @endpoint get /api/addresses/locationBatchById
   * @param batchId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesLocationBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesLocationBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesLocationBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesLocationBatchByIdGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'batchId',
      <any>batchId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/locationBatchById`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets batch details i.e. list of locations created in bulk per batch(csv file upload) (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView)
   * @endpoint get /api/addresses/locationBatchDetail
   * @param batchId
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesLocationBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesLocationBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesLocationBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesLocationBatchDetailGet(
    batchId?: number,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'batchId',
      <any>batchId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/locationBatchDetail`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * gets a list of batches per customer used for creating locations in bulk (Role Permissions Required: FlagsCanImportBulkLocations; LocationsView)
   * @endpoint get /api/addresses/locationBatches
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesLocationBatchesGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public apiAddressesLocationBatchesGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public apiAddressesLocationBatchesGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public apiAddressesLocationBatchesGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/locationBatches`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Merge coordinate addresses into an existing coordinate address (Role Permissions Required: LocationsEdit) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint put /api/addresses/mergeIntoExisting
   * @param xTiveAccountId Account Id
   * @param mergeIntoExistingLocationModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesMergeIntoExistingPut(
    xTiveAccountId?: number,
    mergeIntoExistingLocationModel?: MergeIntoExistingLocationModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiAddressesMergeIntoExistingPut(
    xTiveAccountId?: number,
    mergeIntoExistingLocationModel?: MergeIntoExistingLocationModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiAddressesMergeIntoExistingPut(
    xTiveAccountId?: number,
    mergeIntoExistingLocationModel?: MergeIntoExistingLocationModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiAddressesMergeIntoExistingPut(
    xTiveAccountId?: number,
    mergeIntoExistingLocationModel?: MergeIntoExistingLocationModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/mergeIntoExisting`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: mergeIntoExistingLocationModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Merge Coordinate Addresses into a new coordinate address (Role Permissions Required: LocationsEdit) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint put /api/addresses/mergeIntoNew
   * @param xTiveAccountId Account Id
   * @param mergeIntoNewLocationModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesMergeIntoNewPut(
    xTiveAccountId?: number,
    mergeIntoNewLocationModel?: MergeIntoNewLocationModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<number>;
  public apiAddressesMergeIntoNewPut(
    xTiveAccountId?: number,
    mergeIntoNewLocationModel?: MergeIntoNewLocationModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<number>>;
  public apiAddressesMergeIntoNewPut(
    xTiveAccountId?: number,
    mergeIntoNewLocationModel?: MergeIntoNewLocationModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<number>>;
  public apiAddressesMergeIntoNewPut(
    xTiveAccountId?: number,
    mergeIntoNewLocationModel?: MergeIntoNewLocationModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/mergeIntoNew`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<number>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: mergeIntoNewLocationModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Get coordinate addresses with OData (Role Permissions Required: LocationsView) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint get /api/addresses/odata
   * @param includeDefaultLocations Include tive default locations in search results
   * @param xTiveAccountId Account Id
   * @param $apply Apply a set of transformations to the result set
   * @param $select A list of columns to be returned.
   * @param $search A string search term to filter the results list.
   * @param $top The max number of records.
   * @param $skip The number of records to skip.
   * @param $filter A function that must evaluate to true for a record to be returned.
   * @param $orderby Determines what values are used to order a collection of records.
   * @param $expand Use to add related query data.
   * @param $count Request only the count of records. (true|false)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesOdataGet(
    includeDefaultLocations?: boolean,
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ODataResponse>;
  public apiAddressesOdataGet(
    includeDefaultLocations?: boolean,
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ODataResponse>>;
  public apiAddressesOdataGet(
    includeDefaultLocations?: boolean,
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ODataResponse>>;
  public apiAddressesOdataGet(
    includeDefaultLocations?: boolean,
    xTiveAccountId?: number,
    $apply?: string,
    $select?: string,
    $search?: string,
    $top?: string,
    $skip?: string,
    $filter?: string,
    $orderby?: string,
    $expand?: string,
    $count?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'includeDefaultLocations',
      <any>includeDefaultLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$apply',
      <any>$apply,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$select',
      <any>$select,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$search',
      <any>$search,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$top',
      <any>$top,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$skip',
      <any>$skip,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$filter',
      <any>$filter,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$orderby',
      <any>$orderby,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$expand',
      <any>$expand,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      '$count',
      <any>$count,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/odata`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ODataResponse>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Register new coordinate addresses (Role Permissions Required: LocationsCreate) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint post /api/addresses
   * @param allowNoAddressName
   * @param xTiveAccountId Account Id
   * @param coordinateAddress
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesPost(
    allowNoAddressName?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CoordinateAddress>;
  public apiAddressesPost(
    allowNoAddressName?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CoordinateAddress>>;
  public apiAddressesPost(
    allowNoAddressName?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CoordinateAddress>>;
  public apiAddressesPost(
    allowNoAddressName?: boolean,
    xTiveAccountId?: number,
    coordinateAddress?: CoordinateAddress,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'allowNoAddressName',
      <any>allowNoAddressName,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CoordinateAddress>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: coordinateAddress,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Similar to GetCoordinateAddresses but accepts search query as string. This is called mostly from Public API (Role Permissions Required: LocationsView) (Resource Permissions Required: LocationsManageCollaborators)
   * @endpoint get /api/addresses/savedLocationsList
   * @param id
   * @param latitude
   * @param longitude
   * @param locationName
   * @param exactName
   * @param locationAddress
   * @param numberOfShipmentsUsing
   * @param disabled
   * @param searchTerm
   * @param pageSize
   * @param pageNumber
   * @param sortField
   * @param sortOrder
   * @param addressType
   * @param isShipmentsCountUsed
   * @param loadCollaborators
   * @param loadLabels
   * @param loadCreator
   * @param includeDefaultLocations
   * @param includeSharedLocations
   * @param includeSharedLocationsExternally
   * @param excludeTotalCount
   * @param getInheritedAddressByParentLocationId
   * @param onlySavedLocations
   * @param loadSharedFromOrganizationName
   * @param prioritizeExternalSharedAddresses
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesSavedLocationsListGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<CoordinateAddressListLengthResult>;
  public apiAddressesSavedLocationsListGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<CoordinateAddressListLengthResult>>;
  public apiAddressesSavedLocationsListGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<CoordinateAddressListLengthResult>>;
  public apiAddressesSavedLocationsListGet(
    id?: number,
    latitude?: number,
    longitude?: number,
    locationName?: string,
    exactName?: string,
    locationAddress?: string,
    numberOfShipmentsUsing?: number,
    disabled?: boolean,
    searchTerm?: string,
    pageSize?: number,
    pageNumber?: number,
    sortField?: string,
    sortOrder?: string,
    addressType?: Array<CoordinateAddressType>,
    isShipmentsCountUsed?: boolean,
    loadCollaborators?: boolean,
    loadLabels?: boolean,
    loadCreator?: boolean,
    includeDefaultLocations?: boolean,
    includeSharedLocations?: boolean,
    includeSharedLocationsExternally?: boolean,
    excludeTotalCount?: boolean,
    getInheritedAddressByParentLocationId?: number,
    onlySavedLocations?: boolean,
    loadSharedFromOrganizationName?: boolean,
    prioritizeExternalSharedAddresses?: boolean,
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Id',
      <any>id,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Latitude',
      <any>latitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Longitude',
      <any>longitude,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationName',
      <any>locationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExactName',
      <any>exactName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LocationAddress',
      <any>locationAddress,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'NumberOfShipmentsUsing',
      <any>numberOfShipmentsUsing,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'Disabled',
      <any>disabled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SearchTerm',
      <any>searchTerm,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageSize',
      <any>pageSize,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PageNumber',
      <any>pageNumber,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortField',
      <any>sortField,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'SortOrder',
      <any>sortOrder,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'AddressType',
      <any>addressType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IsShipmentsCountUsed',
      <any>isShipmentsCountUsed,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCollaborators',
      <any>loadCollaborators,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadLabels',
      <any>loadLabels,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadCreator',
      <any>loadCreator,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeDefaultLocations',
      <any>includeDefaultLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocations',
      <any>includeSharedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'IncludeSharedLocationsExternally',
      <any>includeSharedLocationsExternally,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'ExcludeTotalCount',
      <any>excludeTotalCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'GetInheritedAddressByParentLocationId',
      <any>getInheritedAddressByParentLocationId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'OnlySavedLocations',
      <any>onlySavedLocations,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'LoadSharedFromOrganizationName',
      <any>loadSharedFromOrganizationName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'PrioritizeExternalSharedAddresses',
      <any>prioritizeExternalSharedAddresses,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/savedLocationsList`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CoordinateAddressListLengthResult>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Update a node Type on selected locations (Role Permissions Required: LocationsEdit)
   * @endpoint post /api/addresses/setLocationsNodeType
   * @param xTiveAccountId Account Id
   * @param setStandardizedNodeTypeModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiAddressesSetLocationsNodeTypePost(
    xTiveAccountId?: number,
    setStandardizedNodeTypeModel?: SetStandardizedNodeTypeModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<number>>;
  public apiAddressesSetLocationsNodeTypePost(
    xTiveAccountId?: number,
    setStandardizedNodeTypeModel?: SetStandardizedNodeTypeModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<number>>>;
  public apiAddressesSetLocationsNodeTypePost(
    xTiveAccountId?: number,
    setStandardizedNodeTypeModel?: SetStandardizedNodeTypeModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<number>>>;
  public apiAddressesSetLocationsNodeTypePost(
    xTiveAccountId?: number,
    setStandardizedNodeTypeModel?: SetStandardizedNodeTypeModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/addresses/setLocationsNodeType`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<number>>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: setStandardizedNodeTypeModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
